import React from 'react';
import { useNavigate } from 'react-router-dom';

const CARD_OPTIONS = [
  {
    title: 'Personal Loan',
    subtitle: 'Up to ₹5L via verified lenders',
    badge: 'Fast disbursal',
    route: 'https://snapfunds.in/',
    external: true,
    tone: 'lavender',
  },
  {
    title: 'Business Loan',
    subtitle: 'Scale working capital or expansion',
    badge: 'Popular',
    route: '/business-expansion',
    tone: 'sky',
  },
  {
    title: 'Supply Chain Financing',
    subtitle: 'Vendor finance for anchors',
    badge: 'New',
    route: '/inventory-financing',
    tone: 'mint',
  },
];

const DashboardIntentSection = () => {
  const navigate = useNavigate();

  const handleNavigate = (route, external) => {
    if (external) {
      window.open(route, '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(route);
  };

  return (
    <section className="dashboard-intent-section">
      <div className="intent-header">
        <div>
          <p className="dashboard-eyebrow">Journeys</p>
          <h2>What are you looking for?</h2>
        </div>
        <span className="intent-helper">Tap on a card to jump directly into the journey</span>
      </div>
      <div className="dashboard-intent-grid">
        {CARD_OPTIONS.map((card) => (
          <button
            key={card.title}
            type="button"
            className={`intent-card ${card.tone}`}
            onClick={() => handleNavigate(card.route, card.external)}
          >
            <div className="intent-card-top">
              <div className="intent-card-icon" aria-hidden="true">
                <span />
              </div>
              {card.badge && <span className="intent-card-badge">{card.badge}</span>}
            </div>
            <h3>{card.title}</h3>
            <p>{card.subtitle}</p>
            <div className="intent-card-cta">
              <span>Explore</span>
              <span aria-hidden="true">→</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default DashboardIntentSection;

